import React from "react";
import Modal from '@mui/material/Modal';


export default function CModal(props) {
  return (
    <Modal
      open={props.isOpen}
      onClose={props.handleClose}
      aria-labelledby={props?.labelTitle}
      aria-describedby={props?.describeTitle}
      sx={{
        display: 'flex',
        alignItems: 'flex-start', // Align to top
        justifyContent: 'center',
        paddingTop: '40px', // Add spacing from top
        overflowY: 'auto',
        maxHeight: '100vh',
        ...props?.style,
      }}
    >
      <div
        className={props?.className}
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
          margin: '0 16px'
        }}
      >
        {props?.body}
      </div>
    </Modal>
  );
}